import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StateManagementButtonsComponent } from './state-management-buttons.component';
import { SharedModule } from '../../shared.module';
import { MaterialModule } from '../../material.module';



@NgModule({
  declarations: [
    StateManagementButtonsComponent
  ],
  exports: [
    StateManagementButtonsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule
  ]
})
export class StateManagementButtonsModule { }
